export default function authHeader( x ) {
  let token = localStorage.getItem('token');

  if ( x ) {
    return { 'X-Custom-Token': process.env.VUE_APP_X_TOKEN }
  } else if ( !x && token ) {
    return { Authorization: 'Bearer ' + token }
  } else {
    return {}
  }
}
